/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Einvoice_Auto_Failed_HintInputs */

const vi_pos_einvoice_auto_failed_hint = /** @type {(inputs: Pos_Einvoice_Auto_Failed_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã bán xong và nằm trong nhóm "Chờ xuất hóa đơn". Có thể phát hành tay ngay bên dưới hoặc ở màn Đơn hàng.`)
};

/**

* @param {Pos_Einvoice_Auto_Failed_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_einvoice_auto_failed_hint = /** @type {((inputs?: Pos_Einvoice_Auto_Failed_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Einvoice_Auto_Failed_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_einvoice_auto_failed_hint(inputs)
});